import { useTranslation } from 'react-i18next';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import { Alert, Dialog } from '@insights-ltd/design-library/components';
import { TeamResponse } from 'api';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';

export type DeleteTeamDialogProps = {
  team?: TeamResponse | null;
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  deleting: boolean;
};

const DeleteTeamDialog = ({
  team,
  open,
  onClose,
  onConfirmDelete,
  deleting,
}: DeleteTeamDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      title={t('ui.event-management.learners.teams.delete-dialog.title')}
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      content={
        <Box>
          <DialogContentText
            id="delete-dialog-heading"
            color="textPrimary"
            variant="h6"
          >
            {t('ui.event-management.learners.teams.delete-dialog.heading', {
              teamName: team?.name,
            })}
          </DialogContentText>
          <DialogContentText
            id="delete-dialog-description"
            color="textSecondary"
            variant="body1"
          >
            {t('ui.event-management.learners.teams.delete-dialog.body')}
          </DialogContentText>
          <Box
            sx={{
              py: (theme) => theme.spacing(spacingSizeMap.XS),
            }}
          />
          <Alert severity="error">
            {t('ui.event-management.learners.teams.delete-dialog.alert')}
          </Alert>
        </Box>
      }
      onSubmit={onConfirmDelete}
      primaryButtonText={t(
        'ui.event-management.learners.teams.delete-dialog.confirm',
      )}
      disablePrimaryButton={deleting}
      secondaryButtonText={t(
        'ui.event-management.learners.teams.delete-dialog.cancel',
      )}
    />
  );
};

export default DeleteTeamDialog;
